export function formatNumberWithCommas(value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const numericValue = value.toString().replace(/[^0-9.-]/g, "");
  if (numericValue === "" || numericValue === "-") {
    return "";
  }
  return Number(numericValue).toLocaleString("en-US");
}

export const formatNumberWithoutCommas = (value) => {
  if (!value) return "";
  return String(value).replace(/,/g, '');
};
